<template>
    <div>
        <Dropdown
            v-model="selectedAssessment"
            :options="assessments"
            filter
            optionLabel="name"
            optionValue="code"
            placeholder="Select an assessment"
            @change="emit('update:modelValue', selectedAssessment)"
            :class="{ 'p-invalid': props.isInvalid }"
            showClear
        />
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits } from 'vue';
import { useAssessmentStore } from '../modules/assessment/store';
import { storeToRefs } from 'pinia';

const emit = defineEmits(['update:modelValue']);
// props
const props = defineProps({
    modelValue: {
        type: String,
    },
    userProfile: {
        type: Boolean,
        default: false,
    },
    isInvalid: {
        type: Boolean,
    },
});

const assessmentStore = useAssessmentStore();
// states
const { assessments } = storeToRefs(assessmentStore);
const selectedAssessment = ref(null);

onMounted(() => {
    // load all assessments
    loadAssessments();
    // check if modelValue exists
    if (props.modelValue) {
        loadSelectedAssessment();
    }
});
// actions
const loadAssessments = async () => {
    // check if assessments already exists, if yes then dont need to fetch again
    if (!assessments.value || assessments.value?.length <= 0) {
        await assessmentStore.fetchAllAssessments(props.userProfile);
    }
};

const loadSelectedAssessment = () => {
    selectedAssessment.value = props.modelValue;
};
</script>
